import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalManagerContext } from '../../ModalsManager';
import PlotWrapper from '../../common/PlotWrapper';
import BarChart from '../../common/charts/BarChart';
import PieChart from '../../common/charts/PieChart';
import ConnectionsAreaChart from '../../common/charts/ConnectionsAreaChart';

import chartTranslations from '../../common/charts/translations';
import useFetch from '../../../utils/useFetch';
import useStyles from './styles';


const url = (placementId) => `${process.env.REACT_APP_API_URL}/analytics/user_types/${placementId}`

const UserTypes = ({ state }) => {
  const { t } = useTranslation(['translation'])
  const openModal = useContext(ModalManagerContext);
  const { render } = useFetch(url(state.placementSelected), openModal);

  const classes = useStyles();

  return render(data => (
    <>
      <PlotWrapper title={t('ANALYTICS.WIFI_CONSUMPTION')}>
        <ConnectionsAreaChart data={data.event_data} />
      </PlotWrapper>
      <div className={classes.userTypesContainer}>
        <PlotWrapper
          title={t('ANALYTICS.LOGIN_TYPE')}
          showTooltip
          tooltipText={t('ANALYTICS.DEFAULT_TOOLTIP_TEXT')}
        >
          <PieChart
            title={t('ANALYTICS.VISITOR_ENTRY')}
            data={getLoginData(data.login_choices_stats, t)}
            unitName={t('ANALYTICS.VISITOR_ENTRY_UNIT')}
            smallPie
          />
        </PlotWrapper>
        <PlotWrapper
          title={t('ANALYTICS.VISIT_FRECUENCY')}
          showTooltip
          tooltipText={t('ANALYTICS.DEFAULT_TOOLTIP_TEXT')}
        >
          <PieChart
            title={t('ANALYTICS.MONTHLY_RATE')}
            data={transformDataForChart(data.returning_visitors, t)}
            unitName={t('ANALYTICS.MONTHLY_RATE_UNIT')}
            smallPie
          />
        </PlotWrapper>
        <PlotWrapper
          title={t('ANALYTICS.VISIT_FRECUENCY_DETAILED')}
          showTooltip
          tooltipText={t('ANALYTICS.DEFAULT_TOOLTIP_TEXT')}
        >
          <BarChart
            data={transformDataForChart(data.visiting_frequency, t, true)}
            legendTitle={t('ANALYTICS.VISIT_FRECUENCY_LEGEND')}
            unitName={t('ANALYTICS.VISIT_FRECUENCY_UNIT')}
          />
        </PlotWrapper>
      </div>
    </>
  ));
};

const transformDataForChart = (data, t, noTranslations = false) =>
  Object.keys(data).map(key => ({
    value: data[key],
    name: noTranslations ? key : t(chartTranslations(key)),
  }));

const getLoginData = ({ loginFacebook=0, register=0, ...rest }, t) => [
  { name: t(chartTranslations('loginFacebook')), value: loginFacebook },
  { name: t(chartTranslations('register')), value: register },
  ...transformDataForChart(rest, t)
];

export default UserTypes;
